import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'

import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import DashboardIcon from '@material-ui/icons/Dashboard'
import { sendMessage } from '../../utils/iframeUtil'

const StyledDashboard = styled(ListItem)`
  width: '100%';
  border-radius: 3px;
  border: 1px solid gray;
  color: white;
  margin: 10px;
  padding: 10px;
`

const Dashboard = ({ dashboard }) => {
  const onLinkClick = (type, data) => () => sendMessage({ type, data })

  return (
    <StyledDashboard button onClick={onLinkClick('gotoDashboard', dashboard.dashboardId)}>
      <ListItemIcon>
        <DashboardIcon />
      </ListItemIcon>
      <ListItemText primary={dashboard.name} />
    </StyledDashboard>
  )
}

Dashboard.propTypes = {
  dashboard: PropTypes.shape({
    name: PropTypes.string.isRequired,
    dashboardId: PropTypes.string.isRequired
  }).isRequired
}

export default Dashboard
